import { useTranslation } from 'react-i18next'
import {
  PlayerSearchTableRow,
  usePlayerSearchFilters,
  usePlayerSearchTable,
} from '@/views/player-search'
import { PlayerCardModels } from '@/state/player-card'
import { TableGenericComponent } from '@/views/components'

import NoContentAvailable from '@/views/components/no-content-available/index.component'
import { Box } from '@mui/material'

export const PlayerSearchTableComponent = () => {
  const { t } = useTranslation()
  const {
    isLoadingSearch,
    sortedRows,
    headCells,
    pagination,
    order,
    orderBy,
    createSortHandler,
    onPlayerClick,
  } = usePlayerSearchTable()

  const { handleChangeLimit, handleChangePage } = usePlayerSearchFilters()

  const body = sortedRows.map((row: PlayerCardModels.PlayerCardType) => (
    <PlayerSearchTableRow
      key={row.id}
      row={row}
      onPlayerClick={onPlayerClick}
    />
  ))

  return (
    <TableGenericComponent<PlayerCardModels.PlayerCardType>
      order={order}
      orderBy={orderBy}
      createSortHandler={createSortHandler}
      headCells={headCells}
      rowLength={sortedRows.length}
      pagination={pagination}
      handleChangePage={handleChangePage}
      handleChangeLimit={handleChangeLimit}
      isLoading={isLoadingSearch}
      body={body}
      noContentElement={
        <Box sx={{ display: 'flex', marginTop: 30 }}>
          <NoContentAvailable
            title={t('messages.noData')}
            instruction={t('messages.noResultsFound')}
            subInstruction={t('playerCard.noPlayerIdData')}
          />
        </Box>
      }
    />
  )
}
